/*
 * @Description: 活动主页title部分
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-08 14:25:52
 * @LastEditors: zhouhong07
 * @LastEditTime: 2020-02-26 09:30:30
 */
import React, { useEffect } from 'react' ;
import Cookie from '../../util/cookie';

const ActiveTitle = () => {
  const getCity = () => {
    let flag = Cookie.get('commontopbar_ipcity').split('|') ;
    let item = flag[0] ;
    return item ;
  }
  const handleJumpToB = () => {
    // let flag = Cookie.get('PPU') ;
    // if(flag) {
      // window.open(`//employer.58.com/position/post?/position/display`);
      window.open('//survey.58.com/?id=1008776&hash=34py') ;
    // }else{
    //   window.location.href = "//passport.58.com/login/?path=//employer.58.com/position/post?/position/display" ;
    // }
  }

  const handleJumpToC = () => {
    let flag = Cookie.get('PPU') ;
    if(flag) {
      window.open(`//my.58.com/pro/myjob/index/`);
    }else{
      window.location.href = `//passport.58.com/login/?path=${window.location.protocol}//my.58.com/pro/myjob/index/` ;
    }
  }
  
  useEffect(() => {
    // console.log("index-title",getCity());
  })
  return(
    <div className="active-title-block">
      <div className="main-title-img"></div>
      <div className="main-title-intro"></div>
      <p className="main-title-big">
        58同城助力人社部等部门开展<br/>
        “2020年春风行动暨就业援助月”活动
      </p>
      <p className="main-title-small">
        为了全面贯彻党的十九大和十九届二中、三中、四中全会精神，落实稳就业和打赢脱贫攻坚战决策部署，人力资源社会保障部、国务院扶贫办、全国总工会、全国妇联、中国残联定于2020年一季度在全国开展“2020年春风行动暨就业援助月”专项服务活动，集中帮扶农民工、就业困难人员等劳动者就业创业。
      </p>
      <div className="main-title-button-block">
        <div className="main-title-button" onClick={handleJumpToB}>我要招人</div>
        <div className="main-title-button" onClick={handleJumpToC}>我要求职</div>
      </div>
    </div>
  )
}

export default React.memo(ActiveTitle) ;